import { defineStore } from 'pinia'

const UserInfo = defineStore('User', {
	// 开启数据持久化，存储到 localStorage
	persist: {
		enabled: true,
		strategies: [
			{ storage: localStorage },
		],
	},
	state: () => {
		return {
			"id": '', // 用户ID
			"md5OpenId": "",// 微信openId
			"nickName": '', // 微信昵称
			"headImg": '', // 微信头像
			"token": '', // 登录token
			"prizeId": null, //null 未抽奖, 0: 未中奖, 1: 一等奖, 2: 二等奖, 3: 三等奖
			"code": "", //兑换码,只有一等奖才有兑换码
			"drawCount": 0, //0: 无抽奖机会, 1: 有抽奖机会
			"shareCount": 0,//用户分享次数


			// "id": 1,
			// "md5OpenId": "56CA71E29DB0E7C5",
			// "nickName": "",
			// "headImg": "",
			// "prizeId":null, //null 未抽奖, 0: 未中奖, 1: 一等奖, 2: 二等奖, 3: 三等奖
			// "code":"", //兑换码,只有一等奖才有兑换码
			// "drawCount":0, //0: 无抽奖机会, 1: 有抽奖机会
			// "shareCount": 0,//用户分享次数
		}
	},
	getters: {
		// 判断用户是否已登录（通过openId判断）
		isLoggedIn: (state) => !!state.md5OpenId,
	},
	actions: {
		// 将从后端获取的用户信息，更新到state上
		updateUserData(userData) {
			Object.keys(userData).forEach((key) => {
				if (key == null) {
					return
				}
				if (key in this) {
					this[key] = userData[key]
				}
			})
		},
		// 设置微信用户信息
		setWeChatUserInfo({ md5OpenId, nickname, headImg, token, id }) {
			if (md5OpenId) this.md5OpenId = md5OpenId
			if (nickname) this.nickName = nickname
			if (headImg) this.headImg = headImg
			if (token) this.token = token
			if (id) this.id = id
		},
		// 清除用户信息（登出）
		clearUserInfo() {
			this.id = ''
			this.md5OpenId = ''
			this.nickName = ''
			this.headImg = ''
			this.token = ''
		},
	},
})

export default UserInfo



// WEBPACK FOOTER //
// ./src/store/userStore.js